import React from 'react';

import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import * as styles from './horizontal-align.module.css';
import { AlmaLink } from '../../../alma-link';
import { PortableText } from '../../../portableText';

const ALIGNMENTS_IN_ORDER = ['leftAligned', 'rightAligned'];

export function HorizontalAlignHero({
  _rawHeroCopy,
  backgroundColor,
  ctas = [],
  fadeEffects,
  horizontalAlignment,
  image,
  imageAlignment,
  mobileImage,
  mobileStackOrder,
  verticalAlignment,
  verticalPadding
}) {
  const imagePosition = ALIGNMENTS_IN_ORDER.indexOf(imageAlignment);

    // hooks
    const isMobile = useMediaQuery('(max-width: 799px)');
    const isTablet = useMediaQuery(
      '(min-width: 800px) and (max-width: 1279px)'
    );
    const isDesktop = useMediaQuery('(min-width: 1280px)');

  // content padding
  const modulePaddingTop = verticalPadding?.modulePaddingTop;
  const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

  // image data
  const desktopImageData = getImage(image?.asset);
  const mobileImageData = getImage(mobileImage?.asset);

  // preview image data
  const desktopPreviewImage = image?.asset?.url;
  const mobilePreviewImage = mobileImage?.asset?.url;

  // fade effects
  const enableFadeEffect = fadeEffects?.enableFadeEffect;
  const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

  return (

    <div
      className={
        classNames(
          backgroundColor && `b${backgroundColor}`,
          styles.moduleContainer,
          mobileStackOrder === 'imageOnTop' && styles.imageOnTop,
          mobileStackOrder === 'imageOnBottom' && styles.imageOnBottom,
        )
      }
    >
      <div
        className={
          classNames(
            styles.gridWrapper
          )
        }
      >
        {desktopImageData && imagePosition < 1 && (
          <GatsbyImage
            alt={image?.alt || ''}
            className={styles.image}
            image={isMobile ? mobileImageData : desktopImageData}
          />
        )}
        {(!desktopImageData && desktopPreviewImage) && imagePosition < 1 && (
          <img
            alt={image?.alt || ''}
            className={styles.image}
            src={isMobile ? mobilePreviewImage : desktopPreviewImage}
          />
        )}
        <div
          className={
            classNames(
              enableFadeEffect && 'reveal',
              fadeEffectDirection && fadeEffectDirection,
              modulePaddingBottom,
              modulePaddingTop,
              styles.contentContainer,
              styles[horizontalAlignment],
              styles[verticalAlignment]
            )
          }
        >
          {_rawHeroCopy && (
            <PortableText blocks={_rawHeroCopy} />
          )}
          {ctas && (
            <div className={styles.ctaContainer}>
              {ctas.map((cta, key) => {
                return (
                  <AlmaLink
                    cta={cta}
                    key={key}
                  />
                );
              })}
            </div>
          )}
        </div>
        {desktopImageData && imagePosition === 1 && (
          <GatsbyImage
            alt={image?.alt || ''}
            className={styles.image}
            image={isMobile ? mobileImageData : desktopImageData}
          />
        )}
        {(!desktopImageData && desktopPreviewImage) && imagePosition === 1 && (
          <img
            alt={image?.alt || ''}
            className={styles.image}
            src={isMobile ? mobilePreviewImage : desktopPreviewImage}
          />
        )}
      </div>
    </div>
  );
};
